var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mastercard_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 28,
    fill: "#fff",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M23.007 7.639h-6.806v12.049h6.806V7.638Z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M16.633 13.665a7.556 7.556 0 0 1 .78-3.35 7.671 7.671 0 0 1 2.191-2.675 7.881 7.881 0 0 0-8.206-.867 7.74 7.74 0 0 0-3.193 2.826 7.578 7.578 0 0 0-1.185 4.065c0 1.438.41 2.847 1.185 4.065a7.739 7.739 0 0 0 3.193 2.827 7.881 7.881 0 0 0 8.206-.867 7.672 7.672 0 0 1-2.19-2.675 7.557 7.557 0 0 1-.78-3.349Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M32.19 13.664a7.58 7.58 0 0 1-1.186 4.066 7.74 7.74 0 0 1-3.194 2.826 7.88 7.88 0 0 1-8.206-.868 7.686 7.686 0 0 0 2.19-2.676 7.567 7.567 0 0 0 0-6.698 7.686 7.686 0 0 0-2.19-2.675 7.88 7.88 0 0 1 8.206-.868 7.74 7.74 0 0 1 3.194 2.826 7.58 7.58 0 0 1 1.185 4.065v.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M31.446 18.411v-.247h.102v-.05h-.257v.05h.11v.247h.045Zm.5 0v-.298h-.079l-.09.213-.091-.213h-.07v.298h.057v-.223l.084.194h.058l.085-.194v.225l.045-.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mastercard_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 28,
    fill: "#fff",
    rx: 4
  })))));
};
export default SvgMastercard;